import React, { useState } from 'react';

const TaskRow = ({ task, currentUser, onStatusChange }) => {
  const [expanded, setExpanded] = useState(false);

  const getPriorityIcon = (priority) => {
    const icons = {
      high: 'M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z',
      medium: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
      low: 'M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728'
    };
    return icons[priority] || icons.medium;
  };

  const getActivityIcon = (type) => {
    const icons = {
      paseo: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
      comida: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      medicación: 'M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2',
      juego: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z'
    };
    return icons[type] || icons.paseo;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-4">
      <div 
        className="p-4 flex items-center cursor-pointer hover:bg-gray-50"
        onClick={() => setExpanded(!expanded)}
      >
        <img src={task.petImage} alt={task.petName} className="w-12 h-12 rounded-full mr-4" />
        <div className="flex-1">
          <h3 className="font-medium">{task.petName}</h3>
          <p className="text-sm text-gray-500">
            {task.activities.length} actividad{task.activities.length !== 1 ? 'es' : ''}
          </p>
        </div>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className={`h-5 w-5 text-gray-400 transform transition-transform ${expanded ? 'rotate-180' : ''}`}
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>

      {expanded && (
        <div className="border-t border-gray-100 p-4">
          {task.activities.map((activity, index) => (
            <div key={index} className="mb-4 last:mb-0">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <div className="bg-cyan-100 p-2 rounded-lg mr-3">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-5 w-5 text-cyan-600" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getActivityIcon(activity.type)} />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium capitalize">{activity.type}</h4>
                    <p className="text-sm text-gray-500">{activity.time} - {activity.caregiver}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="mr-3">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className={`h-5 w-5 ${
                        activity.priority === 'high' ? 'text-red-500' : 
                        activity.priority === 'medium' ? 'text-yellow-500' : 'text-green-500'
                      }`} 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getPriorityIcon(activity.priority)} />
                    </svg>
                  </div>
                  <select
                    value={activity.status}
                    onChange={(e) => onStatusChange(task.id, index, e.target.value)}
                    className="px-3 py-1 border border-gray-300 rounded-md text-sm"
                    disabled={currentUser.role === 'owner'}
                  >
                    <option value="pending">Pendiente</option>
                    <option value="in-progress">En curso</option>
                    <option value="completed">Completada</option>
                  </select>
                </div>
              </div>
              {activity.notes && (
                <div className="bg-gray-50 p-3 rounded-lg text-sm mt-2">
                  <p className="text-gray-600">{activity.notes}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskRow;